/*
 * File: ui-history.ts
 * File Created: 2024-09-04 06:10:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 05:26:26
 * Modified By: Val Liu
 * -----
 */

import { ObjectHelper } from "@root/core/utilities";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIRelationPair,
    EUITagRuleUnion,
} from "../core";

// @uiHistory - make this field default as same as the full row.

@UITag.set()
export class uiHistory extends BaseUITag {
    appliedTo: EUITagTarget[] = [
        EUITagTarget.FormElement,
        EUITagTarget.FormSubmit,
        EUITagTarget.TableBodyCell,
    ];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true;

    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input) ?? true;
        if (rule == false) return null;

        let moreTags: IUITagMoreTagsUnit[] = [];
        moreTags.push(
            {
                tag: "uiDefault",
                rule: (o) => {
                    return o.row?.id
                        ? { ...ObjectHelper.deepClone(o.row), [o.name]: null }
                        : null;
                },
            },
            {
                tag: "uiType",
                rule:
                    input.target === EUITagTarget.FormElement
                        ? "iv-form-void"
                        : "iv-cell-void",
            },
            {
                tag: "uiSubmitIgnore",
                rule: true,
            },
        );
        return {
            specials: {
                moreTags,
            },
        };
    }
}
